import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  apiURL = environment.apiUrl;
  cloudApiUrl = environment.cloudApiUrl;

  constructor(private http: HttpClient) {}

  public get<T>(url: string, params?: any): Observable<T> {
    return this.http.get<T>(`${this.apiURL}${url}`, { params: params });
  }

  public post<T>(url: string, body: any): Observable<T> {
    return this.http
      .post<T>(`${this.apiURL}${url}`, body)
      .pipe(catchError(this.handleError));
  }

  post2<T>(url: string, body: any = {}, options: any = {}): Observable<any> {
    return this.http
      .post<T>(`${this.apiURL}${url}`, body, options)
      .pipe(catchError(this.handleError));
  }

  public post3<T>(
    url: string,
    body: any,
    p0: { withCredentials: boolean }
  ): Observable<T> {
    return this.http
      .post<T>(`${this.apiURL}${url}`, body)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(error);
  }
  public put<T>(url: string, body: any): Observable<T> {
    return this.http.put<T>(`${this.apiURL}${url}`, body);
  }

  public delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${this.apiURL}${url}`);
  }

  public patch<T>(url: string, body: string): Observable<T> {
    return this.http.patch<T>(`${this.apiURL}${url}`, body);
  }
}
